/**
 * @file askmybaby ua校验
 * @author songjum <jiangsong02@baidu.com>
 */
/**
 * 判断当前浏览器是否为askmybaby
 *
 * @return {boolean} 判断当前浏览器是否为askmybaby
 */
export default function is() {
    //新版通过UA判断，老版通过cookie判断
    if (/mybaby\//i.test(navigator.userAgent)) {
        return true;
    }
    else {
        return /APP_VERSION/i.test(document.cookie);
    }
}
//# sourceMappingURL=is.js.map